import { useContext } from 'react';

import { SidebarContext } from '../contexts/sidebar/provider';

export const useSidebar = () => useContext(SidebarContext);
